import apiClient from "../../../network/apiClient";

export const fetchAllCouponsAPI = () => apiClient.get("/coupon/getAll", { handle404Silently: true })
export const deleteCouponAPI = (id) => apiClient.delete(`/coupon/delete/${id}`)
export const updateEnquiryStatusAPI = (body) => apiClient.put("/customerContact/update", body)
export const createCouponAPI = ( body ) => apiClient.post("/coupon/create", body);